import { Edge, GroupItem, Groups } from '../../../typings'
import { GROUP_STATUS, userType } from '../constants'
import serverData from '../utils/server-data'
import { groupApi } from './groupApi'

const moveItemInArray = (array: any[], from: number, to: number) => {
  const item = array.splice(from, 1)[0]
  // the -1 is used because at this point the array does not have the element removed
  array.splice(to - 1, 0, item)
}

//When a group is closed, the server returns it below the active ones
//So we are doing it in the frontend to provide better UX
const sentGroupToBottom = (groups: Groups, group: Edge<GroupItem>) => {
  let firstClosedGroup = groups.edges.findIndex(
    (item) => item.node.status === GROUP_STATUS.CLOSED,
  )

  //If there are no groups closed we want to send it to the final position
  if (firstClosedGroup === -1) {
    firstClosedGroup = groups.edges.length
  }

  const groupToMove = groups.edges.findIndex(
    (item) => item.node.id === group.node.id,
  )

  moveItemInArray(groups.edges, groupToMove, firstClosedGroup)

  //Organize cursors values
  groups.edges.forEach((item, index) => (item.cursor = index + 1))
}

export const closeGroupApiSlice = groupApi.injectEndpoints({
  endpoints: (builder) => ({
    closeGroup: builder.mutation<
      { isEditable: boolean; status: string },
      string
    >({
      query: (id) => ({
        url: `/${id}/close`,
        headers: { 'X-CSRF-Token': (serverData as any)._csrf },
        method: 'PATCH',
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        const queryResult = dispatch(
          groupApi.util.updateQueryData(
            'getCurrentUserGroups',
            { userType: userType.CREATOR },
            (groups) => {
              const groupToClose = groups.edges.find(
                (item) => item.node.id === id,
              )
              sentGroupToBottom(groups, groupToClose)
              groupToClose.node.isEditable = false
              groupToClose.node.status = GROUP_STATUS.CLOSED
            },
          ),
        )

        const detailCloseResult = dispatch(
          groupApi.util.updateQueryData(
            'getGroupDetail',
            id,
            (groupToUpdate) => {
              groupToUpdate.customer.moneyPools.moneyPool.isEditable = false
              groupToUpdate.customer.moneyPools.moneyPool.status =
                GROUP_STATUS.CLOSED
            },
          ),
        )
        try {
          await queryFulfilled
        } catch {
          queryResult.undo()
          detailCloseResult.undo()
        }
      },
      invalidatesTags: (_result, error, arg) =>
        error ? [] : ['eligibility', { type: 'groupDetail', id: arg }],
    }),
  }),
})

export const { useCloseGroupMutation } = closeGroupApiSlice
